export enum ITheme {
  primary = "primary",
  secondary = "secondary",
  tertiary = "tertiary", // light
}

export enum ICardTheme {
  primary = "primary",
  secondary = "secondary",
  tertiary = "tertiary",
  header = "header",
}

export enum IStatus {
  default = "default",
  error = "error",
  warning = "warning",
  success = "success",
  info = "info",
}
